/**
 * Add to Cart Product Popup Component
 * Handles add to cart product popup after product is added to cart
 */

if (!window.Eurus.loadedScript.has('add-to-cart-product-popup.js')) {
  window.Eurus.loadedScript.add('add-to-cart-product-popup.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('addToCartProductPopup', (moneyFormat) => ({
        showPopup: false,
        product: null,
        productId: null,
        moneyFormat: moneyFormat || '{{amount}}',
        init() {
          this.registerEventListeners();
        },

        registerEventListeners() {
          document.addEventListener('eurus:cart:product-added', this.handleProductAdded.bind(this));
        },

        handleProductAdded(event) {
          const productData = event.detail;

          if (productData) {
            this.product = productData;
            this.productId = productData.product_id;
            this.fetchProductFromCart();
          }

          this.openPopup();
        },

        async fetchProductFromCart() {
          try {
            const response = await fetch('/cart.js');

            if (response.ok) {
              const cart = await response.json();

              if (cart.items && cart.items.length > 0) {
                let matchedItem = null;
                
                if (this.productId) {
                  matchedItem = cart.items.find(item => item.product_id === this.productId);
                }
                
                if (!matchedItem) {
                  return;
                }
                
                // Fetch variant data to get compare_at_price
                let compareAtPrice = null;
                if (matchedItem.variant_id && matchedItem.handle) {
                  try {
                    const productUrl = `/products/${matchedItem.handle}.js`; // Returns json object with variants
                    const variantResponse = await fetch(productUrl);
                    if (variantResponse.ok) {
                      const productData = await variantResponse.json();
                      const variant = productData.variants?.find(v => v.id === matchedItem.variant_id);
                      compareAtPrice = variant?.compare_at_price;
                    }
                  } catch (e) {
                    console.warn('Could not fetch variant data:', e);
                  }
                }
                
                this.product = {
                  name: matchedItem.product_title,
                  title: matchedItem.product_title,
                  price: matchedItem.final_price,
                  originalPrice: compareAtPrice || matchedItem.original_price,
                  image: matchedItem.image,
                  url: matchedItem.url,
                  properties: matchedItem.properties || {}
                };
              }
            }

            this.refreshFreeShippingBar();
          } catch (error) {
            console.error('Error fetching product from cart:', error);
          }
        },

        async refreshFreeShippingBar() {
          try {
            const sectionId = document.getElementById('add-to-cart-product-popup')?.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '');
            if (!sectionId) return;

            const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
            if (response.ok) {
              const html = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const newFreeShippingBar = doc.getElementById('popup-freeshipping-bar');
              const currentFreeShippingBar = document.getElementById('popup-freeshipping-bar');
              
              if (newFreeShippingBar && currentFreeShippingBar && Alpine.store('freeshippingBar')) {
                Alpine.store('freeshippingBar').saveProgress(currentFreeShippingBar);
                currentFreeShippingBar.innerHTML = newFreeShippingBar.innerHTML;
              }
            }
          } catch (error) {
            console.error('Error refreshing free shipping bar:', error);
          }
        },

        formatPrice(price) {
          if (!price) return '';

          if (Alpine.store('xHelper') && Alpine.store('xHelper').formatMoney) {
            return Alpine.store('xHelper').formatMoney(price, this.moneyFormat);
          }

          return '$' + (price / 100).toFixed(2);
        },

        openPopup() {
          this.showPopup = true;
          document.body.style.overflow = 'hidden';
        },

        closePopup() {
          this.showPopup = false;
          document.body.style.overflow = '';
        },
      }));
    });
  });
}
